"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _luckyWheelApi = require("@/api/luckyWheelApi");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'LuckyWheelList',
  data: function data() {
    return {
      listLoading: false,
      query: {
        keyword: '',
        status: '',
        sort: 'update_desc'
      },
      tableData: [],
      total: 0,
      pageData: {
        page: 1,
        limit: 10
      }
    };
  },
  computed: {
    hasListFilterActive: function hasListFilterActive() {
      var q = this.query;
      if ((q.keyword || '').trim()) return true;
      if (q.status !== '' && q.status != null) return true;
      return false;
    },
    showAddEmptyBlock: function showAddEmptyBlock() {
      if (this.hasListFilterActive) return false;
      if (this.total > 0) return false;
      return true;
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.fetchList();
    });
  },
  methods: {
    fetchList: function () {
      var _fetchList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var data, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.listLoading = true;
              _context.p = 1;
              _context.n = 2;
              return (0, _luckyWheelApi.luckyWheelPageApi)({
                page: this.pageData.page,
                limit: this.pageData.limit,
                keyword: this.query.keyword,
                status: this.query.status
              });
            case 2:
              data = _context.v;
              this.tableData = data && data.list || [];
              this.total = data && data.total != null ? Number(data.total) : 0;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              this.tableData = [];
              this.total = 0;
            case 4:
              _context.p = 4;
              this.listLoading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function fetchList() {
        return _fetchList.apply(this, arguments);
      }
      return fetchList;
    }(),
    handleSearch: function handleSearch() {
      this.pageData.page = 1;
      this.fetchList();
    },
    handleReset: function handleReset() {
      this.query = {
        keyword: '',
        status: '',
        sort: 'update_desc'
      };
      this.pageData.page = 1;
      this.fetchList();
    },
    handlePageChange: function handlePageChange(page) {
      this.pageData.page = page;
      this.fetchList();
    },
    handleSizeChange: function handleSizeChange(limit) {
      this.pageData.limit = limit;
      this.pageData.page = 1;
      this.fetchList();
    },
    formatCustomers: function formatCustomers(row) {
      if (!row) return '';
      if (row.applyCustomerDesc != null && String(row.applyCustomerDesc).trim() !== '') {
        return String(row.applyCustomerDesc);
      }
      if (Number(row.applyCustomerType) === 0) return '全部';
      return '';
    },
    statusTagType: function statusTagType(status) {
      var n = Number(status);
      if (n === 1) return 'success';
      if (n === 0) return '';
      return 'info';
    },
    goCreate: function goCreate() {
      this.$router.push({
        path: '/marketing/luckyWheel/list/save/create'
      });
    },
    handleView: function handleView(row) {
      var id = row && row.id;
      if (id == null || id === '') return;
      this.$router.push({
        path: "/marketing/luckyWheel/list/save/view/".concat(id)
      });
    },
    handleEdit: function handleEdit(row) {
      var id = row && row.id;
      if (id == null || id === '') return;
      this.$router.push({
        path: "/marketing/luckyWheel/list/save/edit/".concat(id)
      });
    },
    handleCopy: function handleCopy(row) {
      var id = row && row.id;
      if (id == null || id === '') return;
      this.$router.push({
        path: "/marketing/luckyWheel/list/save/copy/".concat(id)
      });
    },
    handleEnd: function () {
      var _handleEnd = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(row) {
        var id, _t2, _t3;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              id = row && row.id;
              if (!(id == null || id === '')) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              _context2.p = 1;
              _context2.n = 2;
              return this.$confirm('确认要结束该活动?', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
              });
            case 2:
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              return _context2.a(2);
            case 4:
              _context2.p = 4;
              _context2.n = 5;
              return (0, _luckyWheelApi.luckyWheelEndApi)(id);
            case 5:
              this.$message.success('已结束');
              this.fetchList();
              _context2.n = 7;
              break;
            case 6:
              _context2.p = 6;
              _t3 = _context2.v;
            case 7:
              return _context2.a(2);
          }
        }, _callee2, this, [[4, 6], [1, 3]]);
      }));
      function handleEnd(_x) {
        return _handleEnd.apply(this, arguments);
      }
      return handleEnd;
    }(),
    handleDelete: function () {
      var _handleDelete = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(row) {
        var id, _t4, _t5;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              id = row && row.id;
              if (!(id == null || id === '')) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              _context3.p = 1;
              _context3.n = 2;
              return this.$confirm('确认要删除该活动?', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
              });
            case 2:
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t4 = _context3.v;
              return _context3.a(2);
            case 4:
              _context3.p = 4;
              _context3.n = 5;
              return (0, _luckyWheelApi.luckyWheelDeleteApi)(id);
            case 5:
              this.$message.success('删除成功');
              this.fetchList();
              _context3.n = 7;
              break;
            case 6:
              _context3.p = 6;
              _t5 = _context3.v;
            case 7:
              return _context3.a(2);
          }
        }, _callee3, this, [[4, 6], [1, 3]]);
      }));
      function handleDelete(_x2) {
        return _handleDelete.apply(this, arguments);
      }
      return handleDelete;
    }()
  }
};